import { createSelector } from 'reselect';
const vaRegions = (state) => state.entities.metaData.vaRegions;

import { getCurrentEmployer } from '../../selectors/employers';
import { getEditingCaseEmployer } from '../cases/selector';

function _locationsByRegionForEmployer(regions, employer) {
  const locations = employer?.uiConfig?.medRecClinicalLocations || [];
  return regions.reduce((result, current) => {
    result[current.id] = locations.filter((l) => l.va_region === current.id);
    return result;
  }, {});
}

export const getLocationsByRegionForCurrentEmployer = createSelector(
  vaRegions,
  getCurrentEmployer,
  _locationsByRegionForEmployer
);
export const getLocationsByRegionForEditingCaseEmployer = createSelector(
  vaRegions,
  getEditingCaseEmployer,
  _locationsByRegionForEmployer
);
